import component from "./component";
import IntervalPromise from "./interval-promise/IntervalPromise";
import TimeSinceFormatter from "./time-since-formatter/TimeSinceFormatter";
import Router from "./router/Router";
import * as env from "./environment";
import { FONT_SIZES } from "../utils/novaTypography";
// TODO: figure out why adding enzyme as a dependency in package.json results in errors when webpack:prod builds

const util = {
  component,
  intervalPromise: IntervalPromise,
  timeSinceFormatter: TimeSinceFormatter,
  router: Router,
  env,
  typography: { FONT_SIZES },
};

export default util;
